import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const modalContent = css`
  display: flex;
  flex-direction: column;
  gap: ${size[32]};
  padding: ${size[24]};

  ${breakpoint.up('sm')} {
    padding: ${size[48]};
  }
`

const shortHeight = css`
  height: calc(100% - 44px);
`
const lastItemHeight = css`
  height: calc(100% - 32px);
`
export const step = (isLast: boolean) => css`
  ${breakpoint.down('xs')} {
    top: 38px;
    ${isLast ? lastItemHeight : shortHeight}
  }
`
